/**
 * @generated SignedSource<<aec196cf7a9a909d19b50fc0d02f15fe>>
 * @relayHash 1b12beab40605fc485cec603e72de636
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 42b08194cc944453aac09f65fbd15b91bf5352ae38433b498436ba84bbdf72b6

import type { ConcreteRequest, Query } from 'relay-runtime';
export type loadQueryWithUserPrefs_filterResultFilterQuery$variables = {
  cloudId: string;
  fieldSetIds: ReadonlyArray<string>;
  filterAri: string;
};
export type loadQueryWithUserPrefs_filterResultFilterQuery$data = {
  readonly jira: {
    readonly fieldSetsById: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly aliases: ReadonlyArray<string> | null | undefined;
          readonly fieldSetId: string;
          readonly isSortable: boolean | null | undefined;
          readonly jqlTerm: string;
        };
      } | null | undefined>;
    };
    readonly filter: {
      readonly jql: string;
    };
  };
};
export type loadQueryWithUserPrefs_filterResultFilterQuery = {
  response: loadQueryWithUserPrefs_filterResultFilterQuery$data;
  variables: loadQueryWithUserPrefs_filterResultFilterQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fieldSetIds"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filterAri"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "filterAri"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "jql"
},
v5 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "fieldSetIds",
    "variableName": "fieldSetIds"
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "fieldSetId"
},
v7 = {
  "kind": "ScalarField",
  "name": "jqlTerm"
},
v8 = {
  "kind": "ScalarField",
  "name": "aliases"
},
v9 = {
  "kind": "ScalarField",
  "name": "isSortable"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "loadQueryWithUserPrefs_filterResultFilterQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v3/*: any*/),
                "kind": "LinkedField",
                "name": "filter",
                "plural": false,
                "selections": [
                  (v4/*: any*/)
                ]
              },
              "action": "THROW",
              "path": "jira.filter"
            },
            {
              "kind": "RequiredField",
              "field": {
                "args": (v5/*: any*/),
                "concreteType": "JiraIssueSearchFieldSetConnection",
                "kind": "LinkedField",
                "name": "fieldSetsById",
                "plural": false,
                "selections": [
                  {
                    "kind": "RequiredField",
                    "field": {
                      "concreteType": "JiraIssueSearchFieldSetEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "RequiredField",
                          "field": {
                            "concreteType": "JiraIssueSearchFieldSet",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "RequiredField",
                                "field": (v6/*: any*/),
                                "action": "THROW",
                                "path": "jira.fieldSetsById.edges.node.fieldSetId"
                              },
                              {
                                "kind": "RequiredField",
                                "field": (v7/*: any*/),
                                "action": "THROW",
                                "path": "jira.fieldSetsById.edges.node.jqlTerm"
                              },
                              (v8/*: any*/),
                              (v9/*: any*/)
                            ]
                          },
                          "action": "THROW",
                          "path": "jira.fieldSetsById.edges.node"
                        }
                      ]
                    },
                    "action": "THROW",
                    "path": "jira.fieldSetsById.edges"
                  }
                ]
              },
              "action": "THROW",
              "path": "jira.fieldSetsById"
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "loadQueryWithUserPrefs_filterResultFilterQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "kind": "LinkedField",
            "name": "filter",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              (v4/*: any*/),
              {
                "kind": "ScalarField",
                "name": "id"
              }
            ]
          },
          {
            "args": (v5/*: any*/),
            "concreteType": "JiraIssueSearchFieldSetConnection",
            "kind": "LinkedField",
            "name": "fieldSetsById",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraIssueSearchFieldSetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraIssueSearchFieldSet",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "42b08194cc944453aac09f65fbd15b91bf5352ae38433b498436ba84bbdf72b6",
    "metadata": {},
    "name": "loadQueryWithUserPrefs_filterResultFilterQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "fb2bc07f25e53dc423fbb95184f83cf2";

export default node;
